import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commentTitle = "三一路面机械数字化施工平台";
const router = new Router({
    routes: [
      {
        path: '/',
        component: resolve => require(['@/pages/login'], resolve),
        name: 'Login',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/to',
        component: resolve => require(['@/pages/supplierAllBack'], resolve),
        name: 'SupplierAllBack',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/homeScreen',
        component: resolve => require(['@/pages/homeScreen'], resolve),
        name: 'HomeScreen',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/homePage',
        component: resolve => require(['@/pages/homePage'], resolve),
        name: 'HomePage',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/pavPage',
        component: resolve => require(['@/pages/pavPage'], resolve),
        name: 'PavPage',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/HomePageZ',
        component: resolve => require(['@/pages/homePageZ'], resolve),
        name: 'HomePageZ',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/devicePage',
        component: resolve => require(['@/pages/devicePage'], resolve),
        name: 'DevicePage',
        meta:{
            title: commentTitle
        }
      },
      {
        path: '/transfer',
        component: resolve => require(['@/pages/transfer'], resolve),
        name: 'Transfer',
        meta:{
            title: commentTitle
        },
        children:[
          // 应用
          
          {
            path: '/transfer/application',
            component: resolve => require(['@/pages/application/index'], resolve),
            name: 'Application',
            meta:{
                title: commentTitle
            },
          },
          
          {
            path: '/transfer/makeRoute',
            component: resolve => require(['@/pages/application/makeRoute'], resolve),
            name: 'MakeRoute',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/demand',
            component: resolve => require(['@/pages/application/demand'], resolve),
            name: 'Demand',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/importDesignData',
            component: resolve => require(['@/pages/application/importDesignData'], resolve),
            name: 'ImportDesignData',
            meta:{
                title: commentTitle
            },
          },
          // 质量管理 START
          {
            path: '/transfer/quality',
            component: resolve => require(['@/pages/quality/index'], resolve),
            name: 'QualityIndex',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/enginDaily',
            component: resolve => require(['@/pages/quality/enginDaily'], resolve),
            name: 'EnginDaily',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/workCheck',
            component: resolve => require(['@/pages/quality/workCheck'], resolve),
            name: 'WorkCheck',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/projectCheck',
            component: resolve => require(['@/pages/quality/projectCheck'], resolve),
            name: 'ProjectCheck',
            meta:{
                title: commentTitle
            },
          },
          // 质量管理 END
          {
            path: '/transfer/monitor',
            component: resolve => require(['@/pages/engineering/monitor'], resolve),
            name: 'Monitor',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/monitorRe',
            component: resolve => require(['@/pages/engineering/monitorRe'], resolve),
            name: 'MonitorRe',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/engineeringList',
            component: resolve => require(['@/pages/engineering/engineeringList'], resolve),
            name: 'EngineeringList',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/engineeringCenter',
            component: resolve => require(['@/pages/engineering/engineeringCenter'], resolve),
            name: 'EngineeringCenter',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/engineeringInfo',
            component: resolve => require(['@/pages/engineering/engineeringInfo'], resolve),
            name: 'EngineeringInfo',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/newJob',
            component: resolve => require(['@/pages/engineering/newJob'], resolve),
            name: 'NewJob',
            meta:{
                title: '新增作业'
            },
          },
          {
            path: '/transfer/check',
            component: resolve => require(['@/pages/engineering/check'], resolve),
            name: 'Check',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/roadList',
            component: resolve => require(['@/pages/engineering/roadList'], resolve),
            name: 'RoadList',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/qualityz',
            component: resolve => require(['@/pages/engineering/quality'], resolve),
            name: 'Qualityz',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/qualityDay',
            component: resolve => require(['@/pages/engineering/qualityDay'], resolve),
            name: 'QualityDay',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/Trans',
            component: resolve => require(['@/pages/engineering/trans'], resolve),
            name: 'Trans',
            meta:{
                title: '道路详情'
            },
          },
          {
            path: '/transfer/engineeringProgress',
            component: resolve => require(['@/pages/engineering/engineeringProgress'], resolve),
            name: 'EngineeringProgress',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/roadInfo',
            component: resolve => require(['@/pages/engineering/roadInfo'], resolve),
            name: 'RoadInfo',
            meta:{
                title: '道路详情'
            },
          },
          {
            path: '/transfer/unroadInfo',
            component: resolve => require(['@/pages/engineering/unroadInfo'], resolve),
            name: 'UnRoadInfo',
            meta:{
                title: '道路详情'
            },
          },
          {
            path: '/transfer/roadSection',
            component: resolve => require(['@/pages/engineering/roadSection'], resolve),
            name: 'RoadSection',
            meta:{
                title: '标段划分'
            },
          },
          {
            path: '/transfer/unroadSection',
            component: resolve => require(['@/pages/engineering/unroadSection'], resolve),
            name: 'UnRoadSection',
            meta:{
                title: '作业块划分'
            },
          },
          {
            path: '/transfer/unroadSet',
            component: resolve => require(['@/pages/engineering/unroadSet'], resolve),
            name: 'UnRoadSet',
            meta:{
                title: '划定道路'
            },
          },
          {
            path: '/transfer/equipmentList',
            component: resolve => require(['@/pages/equipment/equipmentList'], resolve),
            name: 'EquipmentList',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/wordList',
            component: resolve => require(['@/pages/equipment/wordList'], resolve),
            name: 'WordList',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/equipmentMonitor',
            component: resolve => require(['@/pages/equipment/equipmentMonitor'], resolve),
            name: 'EquipmentMonitor',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/speedBack',
            component: resolve => require(['@/pages/equipment/speedBack'], resolve),
            name: 'SpeedBack',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/digitization',
            component: resolve => require(['@/pages/equipment/digitization'], resolve),
            name: 'Digitization',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/equipmentInfo',
            component: resolve => require(['@/pages/equipment/equipmentInfo'], resolve),
            name: 'EquipmentInfo',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/equipmentUseInfo',
            component: resolve => require(['@/pages/equipment/equipmentUseInfo'], resolve),
            name: 'equipmentUseInfo',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/equipmentCareReport',
            component: resolve => require(['@/pages/equipment/equipmentCareReport'], resolve),
            name: 'equipmentCareReport',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/equipmentCenter',
            component: resolve => require(['@/pages/equipment/equipmentCenter'], resolve),
            name: 'EquipmentCenter',
            meta:{
                title: commentTitle
            }
          },
          {
            path: '/transfer/organize',
            component: resolve => require(['@/pages/system/organize'], resolve),
            name: 'Organize',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/entry',
            component: resolve => require(['@/pages/system/entry'], resolve),
            name: 'Entry',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/user',
            component: resolve => require(['@/pages/system/user'], resolve),
            name: 'User',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/role',
            component: resolve => require(['@/pages/system/role'], resolve),
            name: 'Role',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/model',
            component: resolve => require(['@/pages/system/model'], resolve),
            name: 'Model',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/senior',
            component: resolve => require(['@/pages/system/senior'], resolve),
            name: 'Senior',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/version',
            component: resolve => require(['@/pages/system/version'], resolve),
            name: 'Version',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/person',
            component: resolve => require(['@/pages/system/person'], resolve),
            name: 'Person',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/roleInfo',
            component: resolve => require(['@/pages/system/roleInfo'], resolve),
            name: 'RoleInfo',
            meta:{
                title: commentTitle
            },
          },
          {
            path: '/transfer/tenant',
            component: resolve => require(['@/pages/system/tenant'], resolve),
            name: 'Tenant',
            meta:{
                title: commentTitle
            },
          },
        ]
      },
      
    ]
})
router.beforeEach((to,from,next)=>{
  let userRoleList = localStorage.getItem("userRoleList")
  console.log(to,from)
  if(to.path=='/transfer/organize'){
    if(userRoleList.indexOf('menu-f5537397b5fc44dcb11a3589f5345e1d') > -1){
      next()
    }else{
      next(from.path)
    }
  }else if(to.path=='/transfer/user'){
    if(userRoleList.indexOf('menu-ff625541dff24a429d4ebd5ab3593d9e') > -1){
      next()
    }else{
      next(from.path)
    }
  }else if(to.path=='/transfer/role'){
    if(userRoleList.indexOf('menu-e01e7800f83148b78545ee5c3affc857') > -1){
      next()
    }else{
      next(from.path)
    }
  }else if(to.path=='/transfer/senior'){
    if(userRoleList.indexOf('menu-10f4ae9c3e8f405cbc676667a53b7484') > -1){
      next()
    }else{
      next(from.path)
    }
  }else if(to.path=='/transfer/equipmentMonitor'){
    if(userRoleList.indexOf('menu-98e71fd581de4d9da581d4540020f041') > -1){
      next()
    }else{
      next(from.path)
    }
  }else if(to.path=='/transfer/digitization'){
    if(userRoleList.indexOf('menu-0539cf60e9a640829e573784359a2f54') > -1){
      next()
    }else{
      next(from.path)
    }
  }else if(to.path=='/transfer/equipmentList'){
    if(userRoleList.indexOf('menu-2b31d7a8d9354eb99f1bb4f3c5b04ed9') > -1){
      next()
    }else{
      next(from.path)
    }
  }else{
    next()
  }
})
export default router;
